import { env } from '../../constants';
import { WeeksResponse } from './types';

export const WEEKS_API_URL =
  'weeks?groupBy=week&orderDirection=DESC&orderBy=calendarWeek';

export const fetchWork = async (
  token: string | undefined
): Promise<WeeksResponse | undefined> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/${WEEKS_API_URL}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    return undefined;
  }

  return response.json() as Promise<WeeksResponse | undefined>;
};
